import React from 'react';

export const PmiContext = React.createContext({});
